import { useEffect, useState } from 'react';
import { parse, serialize } from 'cookie';

const useCookies = <T>(key: string, defaultValue: T | null = null) => {
  const innerKey = 'cb-' + key;

  const [value, setValue] = useState<T | null>(defaultValue);

  useEffect(() => {
    const parsed = parse(document.cookie);
    if (parsed[innerKey]) {
      const raw = JSON.parse(parsed[innerKey]!) as T;
      setValue(raw);
    }
  }, [innerKey]);

  const update = (raw: T) => {
    document.cookie = serialize(innerKey, JSON.stringify(raw));
    setValue(raw);
  };

  return {
    value,
    update,
  };
};

export default useCookies;
